import React from 'react';
import styled from 'styled-components';
import Title from 'shared/ui/Title';
import UploadCta from 'shared/ui/UploadCta/UploadCta';
import Breadcrumbs from 'shared/ui/Breadcrumbs/Breadcrumbs';

const HeroOuter = styled.div`
    width: 100%;
    background-color: #fbfbfb;
    padding: 60px 50px 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 767px) {
        padding: 48px 20px 56px;
    }
    @media (max-width: 415px) {
        padding: 40px 15px 48px;
    }
`;

const HeroInner = styled.div`
    width: 100%;
    max-width: 860px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Intro = styled.p`
    font-size: 18px;
    line-height: 28px;
    color: #4b5563;
    text-align: center;
    max-width: 640px;
    margin: 0 0 36px;
`;

interface CrumbItem {
    label: string;
    path?: string;
}

interface ArticleHeroProps {
    title: string;
    intro: string;
    /** When true, hides the auto-derived breadcrumbs. Defaults to false (breadcrumbs render on known SEO routes). */
    hideBreadcrumbs?: boolean;
    /**
     * Explicit breadcrumb trail. Needed for routes Breadcrumbs cannot derive, which it does from
     * SEO_PAGES - glossary terms are not in there, so they pass their own trail.
     */
    breadcrumbs?: CrumbItem[];
}

const ArticleHero: React.FC<ArticleHeroProps> = ({ title, intro, hideBreadcrumbs = false, breadcrumbs }) => (
    <HeroOuter>
        <HeroInner>
            {!hideBreadcrumbs && <Breadcrumbs items={breadcrumbs} />}
            <Title as="h1" size="42px" text={title} margin="0 0 16px" textAlign="center" />
            <Intro>{intro}</Intro>
            <UploadCta />
        </HeroInner>
    </HeroOuter>
);

export default ArticleHero;
